/* eslint-disable factorial/no-raw-html */
export const UpsellBackground = () => (
  <svg
    preserveAspectRatio="none"
    width="100%"
    height="100%"
    viewBox="0 0 1068 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3059_11127)">
      <rect width="1068" height="150" fill="#FAF2F4" />
      <g opacity="0.1" filter="url(#filter0_f_3059_11127)">
        <ellipse cx="-33.5" cy="31.5" rx="110.5" ry="35.5" fill="#FF355E" />
      </g>
      <g opacity="0.2" filter="url(#filter1_f_3059_11127)">
        <ellipse cx="33" cy="5.5" rx="118" ry="34.5" fill="#FF9153" />
      </g>
      <g opacity="0.15" filter="url(#filter2_f_3059_11127)">
        <ellipse cx="1010.5" cy="19.5" rx="129.5" ry="52.5" fill="#877FED" />
      </g>
      <g opacity="0.5" filter="url(#filter3_f_3059_11127)">
        <ellipse cx="534" cy="73.5" rx="383" ry="46.5" fill="url(#paint0_diamond_3059_11127)" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_3059_11127"
        x="-180"
        y="-40"
        width="293"
        height="143"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="18" result="effect1_foregroundBlur_3059_11127" />
      </filter>
      <filter
        id="filter1_f_3059_11127"
        x="-145"
        y="-89"
        width="356"
        height="189"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="30" result="effect1_foregroundBlur_3059_11127" />
      </filter>
      <filter
        id="filter2_f_3059_11127"
        x="821"
        y="-93"
        width="379"
        height="225"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="30" result="effect1_foregroundBlur_3059_11127" />
      </filter>
      <filter
        id="filter3_f_3059_11127"
        x="51"
        y="-73"
        width="966"
        height="293"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_3059_11127" />
      </filter>
      <radialGradient
        id="paint0_diamond_3059_11127"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(673.587 73.5) rotate(179.402) scale(581.453 230.328)"
      >
        <stop stopColor="#FFAEBF" />
        <stop offset="1" stopColor="#F9D69B" stopOpacity="0" />
      </radialGradient>
      <clipPath id="clip0_3059_11127">
        <rect width="1068" height="150" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
